import { AsyncDataRequestStatus } from '#app'

export const REQUEST_STATUS: Record<
  AsyncDataRequestStatus,
  AsyncDataRequestStatus
> = {
  idle: 'idle',
  pending: 'pending',
  success: 'success',
  error: 'error',
}
